import { Inject } from 'inversify-props'
import { ContaServiceAdapter } from "../cadastro";

export class FindContaUseCase {
	@Inject('ContaServiceAdapter')
	private contaService!: ContaServiceAdapter

	validarConta = async (email?: string, subdominio?: string): Promise<string> =>
		await this.contaService.validarConta(email, subdominio)
}